import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetRequestsList = () => 
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}DataManagement/GetRequestsList`
	});

export const DeleteRequest = (userId, name) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/DeleteRequest`,
		data: { name, userId }, // Passa o nome do request a ser excluído
	});

export const UpdateRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/Update`,
		data: dto, // Passa o objecto do request para ser actualizado
	});

export const CreateXMLTopologyRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/CreateXMLTopology`,
		data: dto, /// Passa o objecto do request para ser criado
	});

export const CreateS12ThresholdsRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/CreateS12Thresholds`,
		data: dto, /// Passa o objecto do request para ser criado
	});

export const VTKDataRefreshRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportS12ByUser`,
		data: dto, /// Passa o objecto do request para ser criado
	});
	
export const VTKDataRefreshEmailRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportS12KpisFromEmail`,
		data: dto, /// Passa o objecto do request para ser criado
	});
	